import { View } from "binder"
import { ImportViewModel } from "./import-viewModel"

export class ImportView extends View<ImportViewModel>{
    GetViewUniqueId(): string {
        return "V-F5F1C18D-13B9-4E9B-9DAC-0A3C32DDD8EE"
    }
    loadHtml(): string {
        let element = require('./import.html').default;
        let style = require('./import.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;

    confirm(){
        this.dataContext.confirm();
    }
    close(){
        this.dataContext.close();
    }
}
